var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "page"
    }
  }, [_c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("AdminRegionsSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      tabChanged: _vm.tabChanged
    }
  }) : _vm._e(), _c("RegionListComponent", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      type: _vm.selectedTab
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };